import { render, staticRenderFns } from "./reorderable-list.vue?vue&type=template&id=036bf0a8&scoped=true&"
import script from "./reorderable-list.vue?vue&type=script&lang=ts&"
export * from "./reorderable-list.vue?vue&type=script&lang=ts&"
import style0 from "./reorderable-list.vue?vue&type=style&index=0&id=036bf0a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bf0a8",
  null
  
)

export default component.exports